import http from "../utils/http";
//
/**
 *  商品相关接口
 */

/** 获取商品分类 */
export function getCategory(params) {
  return http.get(`goods/category`, params);
}

/** 获取筛选-分类列表-一级 */
export function getScreenCategory(params) {
  return http.get(`/goods/screenCategoryTop`, params);
}
/** 获取筛选-分类列表-其他级 */
export function getScreenCategoryOther(params) {
  return http.get(`/goods/getScreenCategoryOther`, params);
}
/** 获取商品列表 */
export function getGoodsList(params) {
  return http.get(`goods/index`, params);
}
/** 商品搜索 */
export function getGoodsSearch(params) {
  return http.get(`goods/search`, params);
}
/** 商品详情 */
export function getGoodsDetail(params) {
  return http.get(`goods/read`, params);
}
/** 商品一周销量排行榜 */
export function getGoodsSaleTop(params) {
  return http.get(`goods/saleTop`, params);
}
/** 购物车列表*/
export function getGoodsCart(params) {
  return http.get(`GoodsCart/index`, params);
}
/** 添加普通购物车*/
export function addGoodsCart(params) {
  return http.post(`GoodsCart/add`, params);
}
/** 编辑普通购物车*/
export function updateGoodsCart(params) {
  return http.post(`GoodsCart/edit`, params);
}
/** 删除普通购物车*/
export function delGoodsCart(params) {
  return http.post(`GoodsCart/delete`, params);
}
/** 勾选普通购物车*/
export function selectedCart(params) {
  return http.post(`GoodsCart/selection`, params);
}
/** 我的收藏勾选普通购物车*/
export function addAllGoodsCart(params) {
  return http.post(`/GoodsCart/addMore`, params);
}
/** 确认订单*/
export function confirmOrder(params) {
  return http.post(`Order/confirmOrder`, params);
}
/** 提交订单*/
export function submitOrder(params) {
  return http.post(`Order/submitOrder`, params);
}
/** 获取支付渠道*/
export function paymentChannels(params) {
  return http.post(`Order/paymentChannels`, params);
}
/** 提交支付*/
export function pcpayinfo(params) {
  return http.post(`pay/pcpayinfo`, params);
}
/** pc轮询查询支付状态*/
export function getPayStatus(params) {
  return http.post(`Notify/order_success`, params);
}
/** 商品收藏*/
export function collection(params) {
  return http.get(`help/collection`, params);
}
/** 新人特价列表 */
export function getXrtjGoodsList(params) {
  return http.get(`goods/xrtj`, params);
}
/** 再次购买加入购物车 */
export function addbuyAgain(params) {
  return http.post(`Order/buyAgain`, params);
}
/** 秒杀加入购物车 */
export function goodAddSkill(params) {
  return http.post(`GoodsCart/addSkill`, params);
}
/** 套餐加入购物车 */
export function goodAddPackage(params) {
  return http.post(`GoodsCart/addPackage`, params);
}

/** 套餐列表 */
export function getPackageList(params) {
  return http.get(`/goods/package_list`, params);
}

/** 拼团加入购物车 */
export function goodAddScrabble(params) {
  return http.post(`GoodsCart/addScrabble`, params);
}
/** 品牌专场列表 */
export function getPpzcGoodsList(params) {
  return http.get(`/goods/ppzc`, params);
}

/** 一键求购 */
export function getbuyForm(params) {
  return http.post(`/buyZone/buy_form`, params);
}

/** 拼团专区列表 */
export function getScrabbleList(params) {
  return http.get(`/goods/spell_list`, params);
}



// WEBPACK FOOTER //
// ./src/api/goods.js